import React, { useEffect, useState, useRef } from "react";
import { apiGet } from "../../services/api";

export interface PatientSearchResult {
  patient_id: string;
  name?: string;
  mobile?: string;
  [k: string]: unknown;
}

export interface PatientSearchPanelProps {
  onSelect?: (patient: PatientSearchResult) => void;
}

export default function PatientSearchPanel({ onSelect }: PatientSearchPanelProps) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<PatientSearchResult[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setResults([]);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (query.length < 2) {
      setResults([]);
      return;
    }
    const timer = setTimeout(() => {
      apiGet(`/api/patients/search?q=${encodeURIComponent(query)}`)
        .then((res: unknown) => {
          setResults(Array.isArray(res) ? (res as PatientSearchResult[]) : []);
        })
        .catch((err) => {
          console.error("Patient search error:", err);
          setResults([]);
        });
    }, 300);
    return () => clearTimeout(timer);
  }, [query]);

  return (
    <div ref={containerRef} style={{ background: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', padding: '20px', boxShadow: 'var(--mod-shadow-sm)' }}>
      <div style={{ position: 'relative' }}>
        <input
          style={{ width: '100%', padding: '12px 16px', borderRadius: '10px', border: '1px solid #cbd5e1', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box', background: '#f8fafc' }}
          placeholder="Search patient by name or phone..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        
        {results.length > 0 && (
          <div style={{ position: 'absolute', top: 'calc(100% + 8px)', left: 0, right: 0, background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)', overflow: 'hidden', zIndex: 100, maxHeight: '300px', overflowY: 'auto' }}>
            {results.map((p) => (
              <div
                key={p.patient_id}
                onClick={() => {
                  onSelect?.(p);
                  setQuery("");
                  setResults([]);
                }}
                style={{ padding: '12px 16px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', transition: 'background 0.2s' }}
                onMouseOver={e => e.currentTarget.style.background = '#f8fafc'}
                onMouseOut={e => e.currentTarget.style.background = '#fff'}
              >
                <strong style={{ color: '#0f172a', fontSize: '0.95rem' }}>{p.name || "Unknown"}</strong> 
                <span style={{ color: '#64748b', fontSize: '0.85rem' }}>{p.mobile || "N/A"}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
